<template>
  <aside class="sidebar" :class="{ collapsed: collapsed }">
    <div class="brand">
      <span class="brand-mark">EA</span>
      <span class="brand-text">ExAgent</span>
    </div>
    <nav class="nav-list">
      <section v-for="group in menuGroups" :key="group.titleKey" class="nav-group">
        <div class="nav-group-title">{{ $t(group.titleKey) }}</div>
        <router-link
          v-for="item in group.items"
          :key="item.path"
          :to="item.path"
          class="nav-item"
          @click.native="$emit('navigate')"
        >
          <i :class="item.icon"></i>
          <span>{{ $t(item.titleKey) }}</span>
        </router-link>
      </section>
    </nav>
  </aside>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    collapsed: Boolean
  },
  data() {
    return {
      menuGroups: [
        {
          titleKey: 'menuGroups.overview',
          items: [
            { path: '/dashboard', titleKey: 'menu.dashboard', icon: 'el-icon-data-analysis' }
          ]
        },
        {
          titleKey: 'menuGroups.playerBusiness',
          items: [
            { path: '/users', titleKey: 'menu.users', icon: 'el-icon-user' },
            { path: '/recharges', titleKey: 'menu.recharges', icon: 'el-icon-s-finance' },
            { path: '/withdraws', titleKey: 'menu.withdraws', icon: 'el-icon-bank-card' },
            { path: '/player-topup', titleKey: 'menu.playerTopup', icon: 'el-icon-s-promotion' }
          ]
        },
        {
          titleKey: 'menuGroups.myFunds',
          items: [
            { path: '/agent-recharge-orders', titleKey: 'menu.agentRechargeOrders', icon: 'el-icon-coin' },
            { path: '/earnings-withdraw-orders', titleKey: 'menu.earningsWithdrawOrders', icon: 'el-icon-wallet' },
            { path: '/wallet-records', titleKey: 'menu.walletRecords', icon: 'el-icon-document' }
          ]
        },
        {
          titleKey: 'menuGroups.settlement',
          items: [
            { path: '/commission', titleKey: 'menu.commission', icon: 'el-icon-coin' },
            { path: '/settlements', titleKey: 'menu.settlements', icon: 'el-icon-s-order' }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.nav-list {
  height: calc(100vh - 64px);
  overflow-y: auto;
}

.nav-group + .nav-group {
  margin-top: 12px;
}

.nav-group-title {
  padding: 0 18px 6px;
  color: #8d96a8;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/layout/Sidebar.vue